
import { scrollToTop } from "@/utils/_"

export default {
  props: {
    paginator: { type: Object, required: true },
  },

  data: () => ({
    sideNum: 1,
  }),

  computed: {
    groupLen () {
      return this.sideNum * 2 + 1
    },

    page () { return this.paginator.page },
    pages () { return this.paginator.pages },

    isFirstVisible () {
      return this.page >= this.groupLen
    },
    isFirstDotsVisible () {
      return this.page > this.groupLen
    },
    isLastVisible () {
      return this.pages - this.page >= this.groupLen - 1
    },
    isLastDotsVisible () {
      return this.pages - this.page >= this.groupLen
    },

    groupPages () {
      const { page, sideNum } = this
      const pages = []
      for (let p = 1; p <= this.pages; p++)
        if (p >= page - sideNum && p <= page + sideNum) pages.push(p)
      return pages
    },
  },

  watch: {
    paginator () { this.checkPaginatorPage() },
  },

  mounted () {
    this.checkPaginatorPage()
    this.checkQueryPage()
    this.$watch("$route.query.page", () => {
      this.checkQueryPage()
      scrollToTop(false)
    })
  },

  methods: {
    getTo (page) {
      const { pages } = this
      let p = page
      p = p < 1 ? 1 : p > pages ? pages : p
      return { query: { ...this.$route.query, page: p } }
    },

    goToFirstPage () {
      this.$router.replace({ query: { ...this.$route.query, page: 1 } })
        .catch(() => {})
    },

    checkPaginatorPage () {
      const { paginator } = this
      if (paginator.page > paginator.pages) this.goToFirstPage()
    },

    checkQueryPage () {
      const pageNum = Number(this.$route.query.page)
      if (!pageNum || pageNum < 1) this.goToFirstPage()
    },
  },
}
